import { Button } from '../common/Button';
import { GlassPanel } from '../common/GlassPanel';

const COMPANION_DOWNLOAD_URL =
  'https://storage.googleapis.com/war-room-companion-updates/releases/windows/VRMeetCompanion-win-Setup.exe';

/**
 * Settings panel for downloading the VR Meet companion app.
 */
export function CompanionDownloadPanel() {
  const handleDownload = () => {
    window.open(COMPANION_DOWNLOAD_URL, '_blank', 'noopener');
  };

  return (
    <GlassPanel variant="strong" padding="lg" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 bg-brand-gradient opacity-15" />
      <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-brand-teal/30 blur-3xl" />
      <div className="relative flex flex-col gap-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-2xl bg-brand-gradient flex items-center justify-center shadow-glow-brand">
              <svg
                className="h-6 w-6 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 3v12" />
                <path d="m7 10 5 5 5-5" />
                <path d="M5 21h14" />
              </svg>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-ink-300">Companion app</p>
              <h2 className="text-2xl font-semibold text-white">VR Meet Companion</h2>
              <p className="text-sm text-ink-200">Low-latency desktop streaming for Quest</p>
            </div>
          </div>
          <Button variant="primary" size="lg" className="shadow-glow" onClick={handleDownload}>
            <span>Download for Windows</span>
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </Button>
        </div>

        <p className="text-sm text-ink-200">
          Install on your PC, sign in, and your headset will connect automatically on the same
          network. No pairing codes needed.
        </p>

        <div className="grid gap-3 text-sm text-ink-200 md:grid-cols-2">
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-brand-teal shadow-glow-brand" />
            <span>Windows 10/11 only</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-brand-blue shadow-glow" />
            <span>Auto-updates enabled with Velopack</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-brand-green shadow-glow" />
            <span>Uses your VR Meet account for approval</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-white/60" />
            <span>Built for low latency streaming</span>
          </div>
        </div>
      </div>
    </GlassPanel>
  );
}
